module.exports = __webpack_public_path__ + "img/unlock.d8e43e41.svg";